var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"dateInput",staticClass:"form-control",attrs:{"type":"text","name":_vm.name,"id":_vm.name,"required":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }